// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23C5A059%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Montserrat:wght@200;400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sage: #A4C3B2;       /* Premium Light Mint Green */
  --gold: #C5A059;
  --bg: #FFFFFF;
  --bg-soft: #F4F7F5;    /* Luxury ultra-faint mint cream to fill out empty space */
  --text: #333333;
  --radius-soft: 16px;   /* Organic rounded corners for cards and blocks */
  --radius-pill: 30px;   /* Perfectly rounded edges for buttons and navigation */
  
  /* Strict Typography Design Variables */
  --font-classy: 'Cormorant Garamond', serif;
  --font-clean: 'Montserrat', sans-serif;
}

html { scroll-behavior: smooth; }

/* GLOBAL FONTS RESET */
body, 
input, 
select, 
textarea, 
button, 
.sticky-nav a, 
.t-item span, 
.t-item p, 
.calendar-date, 
.hero-label,
.map-card-overlay span {
  font-family: var(--font-clean);
}

h1, h2, h3, h4, 
.section-title, 
.location-name, 
.quote-text,
.footer p {
  font-family: var(--font-classy);
}

body {
  margin: 0;
  color: var(--text);
  background-color: var(--bg);
}

/* GLOBAL WRAPPER */
.timeless-wrapper {
  overflow-x: hidden;
  position: relative;
}

/* ==========================================================================
   MODERN HIGH-PERFORMANCE PARALLAX CLIPPED ENGINE 
   ========================================================================== */
.hero-section {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  clip-path: inset(0 0 0 0);
  overflow: hidden;
}

.hero-section::before {
  content: "";
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.25)), 
              url('https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2000');
  background-size: cover;
  background-position: center;
  z-index: -1;
  will-change: transform;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden; 
}

.hero-label { letter-spacing: 5px; font-size: 0.8rem; }
.hero-section h1 { font-size: clamp(3rem, 9vw, 5.5rem); font-weight: 500; margin: 15px 0; }
.gold-line { width: 60px; height: 1px; background: var(--gold); margin: 0 auto 20px; }

/* NAVIGATION SYSTEM LAYER (DESKTOP DEFAULT) */
.sticky-nav {
  position: sticky;
  top: 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
  padding: 15px 30px;
  z-index: 1000;
  max-width: 500px;
  margin: 0 auto;
  border-radius: var(--radius-pill);
  box-shadow: 0 10px 30px rgba(164, 195, 178, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  width: 100%;
}

.sticky-nav a {
  text-decoration: none;
  color: var(--text);
  font-size: 0.75rem;
  letter-spacing: 2px;
  font-weight: 500;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.sticky-nav a:hover {
  color: var(--sage);
}

.menu-toggle {
  display: none;
}

/* CONTENT LAYOUT & ALTERNATING SECTIONS */
.container { max-width: 900px; margin: 0 auto; padding: 0 20px; }

.info-section { padding: 60px 0; text-align: center; background-color: var(--bg); }
.program-section { padding: 60px 0; text-align: center; background-color: var(--bg-soft); }
.location-section { padding: 60px 0; text-align: center; background-color: var(--bg); }
.rsvp-section { padding: 60px 0; text-align: center; background-color: var(--bg-soft); }

/* LUXURY H2 TYPOGRAPHY */
h2, .section-title { 
  font-size: 3.2rem;       
  font-weight: 500; 
  letter-spacing: 1.5px;   
  color: var(--sage); 
  margin-bottom: 25px; 
  line-height: 1.2;
}

.main-text { font-size: 1.1rem; line-height: 1.9; max-width: 630px; margin: 0 auto 50px; color: #555; }

/* ROMANTIC QUOTE BANNER */
.quote-banner {
  padding: 60px 20px;
  background: var(--bg-soft);
  text-align: center;
  border-top: 1px solid rgba(164, 195, 178, 0.15);
  border-bottom: 1px solid rgba(164, 195, 178, 0.15);
}

.quote-text {
  font-style: italic;
  font-weight: 400;
  font-size: 1.6rem;
  color: var(--text);
  max-width: 550px;
  margin: 0 auto;
  line-height: 1.6;
}

/* IMAGES */
.mid-photo { 
  width: 100%; 
  max-height: 550px; 
  object-fit: cover; 
  border-radius: var(--radius-soft); 
  box-shadow: 0 15px 40px rgba(0,0,0,0.06);
}

/* HIGH-PERFORMANCE CLIPPED PARALLAX IMAGE DIVIDER */
.parallax-divider {
  position: relative;
  height: 55vh;
  clip-path: inset(0 0 0 0);
  overflow: hidden;
}

.parallax-divider::before {
  content: "";
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: url('https://raw.githubusercontent.com/petyonachev92/wedding_website/refs/heads/main/client/public/images/MPN03338.JPG');
  background-size: cover;
  background-position: center;
  z-index: -1;
  will-change: transform;
}

/* OPTICALLY BALANCED ASYMMETRIC TIMELINE */
.timeline-list { 
  margin-top: 40px; 
  background: white;
  padding: 10px;
  border-radius: var(--radius-soft);
  box-shadow: 0 10px 30px rgba(164, 195, 178, 0.08);
  max-width: 420px; 
  margin-left: auto;
  margin-right: auto;
  position: relative; 
}

.timeline-list::before {
  content: '';
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 29%; 
  width: 1px;
  background: linear-gradient(to bottom, transparent, rgba(197, 160, 89, 0.25) 15%, rgba(197, 160, 89, 0.25) 85%, transparent);
  transform: translateX(-50%);
}

.t-item {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2; 
  padding: 16px 0;
}

.t-item span { 
  font-weight: 600; 
  color: var(--gold); 
  width: 28%; 
  text-align: right; 
  padding-right: 15px; 
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1;
}

.t-item p {
  margin: 0;
  font-size: 1rem;
  color: var(--text);
  width: 72%; 
  text-align: left; 
  padding-left: 15px; 
  box-sizing: border-box;
  line-height: 1.3; 
}

/* CALENDAR SECTION INTERACTIVITY */
.calendar-section {
  padding: 60px 0;
  background-color: var(--bg);
  text-align: center;
}

.calendar-card {
  max-width: 350px;
  margin: 0 auto;
  background: white;
  padding: 35px 30px;
  border-radius: var(--radius-soft);
  box-shadow: 0 15px 40px rgba(164, 195, 178, 0.1);
  border: 1px solid #eef2ef;
  cursor: pointer; 
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s ease;
}

.calendar-header h3 {
  font-family: var(--font-classy) !important;
  font-weight: 500;
  letter-spacing: 3px;
  font-size: 1.45rem;
  color: var(--text);
  margin-bottom: 25px;

  /* FORCES NUMBERS TO MATCH THE HEIGHT AND ALIGNMENT OF CYRILLIC LETTERS */
  font-variant-numeric: lining-nums;
  font-feature-settings: "lnum" 1;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  max-width: 320px;
  margin: 0 auto;
}

.calendar-day-label {
  font-size: 0.65rem;
  font-weight: 600;
  color: var(--sage);
  margin-bottom: 10px;
}

.calendar-date-wrapper {
  position: relative;
  width: 100%;
  height: 40px; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.calendar-date {
  font-size: 0.95rem;
  color: #777;
  z-index: 5;
  position: relative;
  line-height: 1; 
  pointer-events: none;
}

.heart-marker {
  position: absolute;
  top: 46%; 
  left: 50%;
  transform: translate(-50%, -43%) !important; 
  width: 60px;
  height: 60px;
  z-index: 2;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none !important;      /* Removes any trace of the old ring borders */
  background: none !important;  /* Clears any leftover circle backgrounds */
}

/* Premium vibrant red filling and shading adjustments */
.heart-svg {
  width: 100%;
  height: 100%;
  fill: var(--sage);                /* High-contrast romantic red fill color */
  stroke: #77b894;              /* Crisp matching border accent alignment */
  stroke-width: 1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wedding-day {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 1.55rem !important;
}

.ring-marker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important; 
  width: 36px;
  height: 36px;
  border: 2px solid var(--gold);
  border-radius: 50%;
  z-index: 2;
  pointer-events: none;
}

.diamond {
  position: absolute;
  top: -5px;
  left: calc(50% - 4px); 
  width: 6px;
  height: 6px;
  background: white;
  border: 2px solid var(--gold);
  transform: rotate(45deg);
  z-index: 3;
}

.empty { height: 35px; }

/* REBALANCED VISUAL WEIGHT LOCATION CARDS */
.location-name {
  font-size: 2.1rem;        
  font-weight: 500;
  letter-spacing: 0.5px;
  color: var(--gold);       
  margin-bottom: 8px;
  line-height: 1.3;
}

.location-address {
  font-size: 0.9rem;
  color: #777;
  margin-bottom: 30px;
}

.location-instructions {
  font-size: 1rem;
  color: var(--text);
  line-height: 1.9;
  max-width: 630px;
  margin: 0 auto 50px;
}

.map-image-card {
  position: relative;
  max-width: 800px;
  height: 400px;
  margin: 0 auto 30px;
  box-shadow: 0 15px 35px rgba(164, 195, 178, 0.15);
  border-radius: var(--radius-soft);
  overflow: hidden;
  cursor: pointer;
}

.map-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.map-card-overlay {
  position: absolute;
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  background: rgba(0, 0, 0, 0.12);
  
  display: flex;
  justify-content: center;
  align-items: flex-end;  /* Changed from 'center' to push the badge to the top edge */
  padding-bottom: 35px;        /* Adds elegant breathing room from the top border */
  box-sizing: border-box;   /* Prevents the padding from distorting the overlay size */
  
  z-index: 2;
  transition: background 0.4s ease;
}

.map-card-overlay span {
  color: white;
  font-size: 0.8rem;
  letter-spacing: 3px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.6);
  padding: 12px 24px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-pill);
  transition: all 0.4s ease;
}

.map-image-card:hover .map-card-img { transform: scale(1.03); }
.map-image-card:hover .map-card-overlay { background: rgba(164, 195, 178, 0.3); }
.map-image-card:hover .map-card-overlay span { background: var(--sage); border-color: var(--sage); }

/* RSVP STACK ARCHITECTURE */
.rsvp-box { 
  background: white; 
  padding: 50px; 
  border-radius: var(--radius-soft); 
  box-shadow: 0 15px 45px rgba(164, 195, 178, 0.1); 
  display: flex;
  flex-direction: column;
  align-items: center;
}

.elegant-form { 
  display: flex; 
  flex-direction: column; 
  gap: 20px; 
  width: 100%;
  max-width: 550px; 
  margin: 30px auto 0; 
}

.guests-loop-container,
.elegant-form textarea,
.add-guest-action-btn,
.gold-btn {
  width: 100%;
  box-sizing: border-box; 
}

.guest-row-card {
  background: #fafbfa;
  border: 1px solid #eef2ef;
  border-left: 4px solid var(--sage);
  padding: 25px;
  border-radius: var(--radius-soft);
  text-align: left;
  box-sizing: border-box; 
}

.guest-row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.guest-row-header h4 {
  margin: 0;
  font-size: 1.2rem; 
  letter-spacing: 0.5px;
  color: var(--text);
  font-weight: 500;
}

.remove-guest-btn {
  background: transparent;
  border: none;
  color: #c94a4a;
  font-size: 0.75rem;
  cursor: pointer;
  letter-spacing: 1px;
}

.guest-fields-stack {
  display: flex;
  flex-direction: column;
  gap: 15px; 
  width: 100%;
  box-sizing: border-box;
}

.form-field-row {
  width: 100%;
  position: relative;
}

.guest-fields-stack input,
.guest-fields-stack select,
.elegant-form textarea {
  width: 100% !important;
  box-sizing: border-box;
  padding: 16px 20px; 
  border: 1px solid #e2e8e4;
  background-color: white;
  border-radius: 12px; 
  font-size: 0.95rem;
  color: var(--text);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.guest-fields-stack input:focus, 
.guest-fields-stack select:focus, 
.elegant-form textarea:focus {
  outline: none;
  border-color: var(--sage);
  box-shadow: 0 0 0 3px rgba(164, 195, 178, 0.12);
}

.guest-fields-stack select {
  cursor: pointer;
  appearance: none; 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 18px center;
  background-size: 16px;
  padding-right: 45px; 
}

.add-guest-action-btn {
  background: transparent;
  border: 1px dashed var(--sage);
  color: var(--sage);
  padding: 15px; 
  font-size: 0.75rem;
  letter-spacing: 2px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 5px 0;
  text-transform: uppercase;
  border-radius: var(--radius-pill);
}

.add-guest-action-btn:hover {
  background: rgba(164, 195, 178, 0.1); 
  border-color: var(--gold);
  color: var(--gold);
}

.gold-btn {
  background: var(--sage);
  color: white;
  border: none;
  padding: 18px;
  letter-spacing: 2px;
  font-weight: 600;
  cursor: pointer;
  border-radius: var(--radius-pill);
  box-shadow: 0 5px 20px rgba(164, 195, 178, 0.2);
}

.gold-btn:hover { 
  background: var(--gold); 
  box-shadow: 0 5px 20px rgba(197, 160, 89, 0.3);
}

/* FOOTER */
.footer { padding: 60px 0; text-align: center; font-size: 0.8rem; letter-spacing: 2px; color: #777; }

/* ERROR CONTAINERS */
.error-message-box {
  background-color: #FDF4F4; 
  border-left: 4px solid #C94A4A; 
  padding: 15px 20px;
  border-radius: 12px;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
}

.error-message-box p {
  margin: 0;
  color: #C94A4A;
  font-size: 0.85rem;
  line-height: 1.5;
  font-weight: 500;
}

/* SUCCESS TEXT LAYOUT PANELS */
.success-message-wrapper {
  text-align: center;
  padding: 30px 10px;
  position: relative; 
}

.success-message-wrapper h3 {
  font-size: 2.6rem;
  color: var(--sage);
  margin: 0 0 15px 0;
  font-weight: 500;
}

.welcome-message-text {
  font-family: var(--font-classy); 
  font-size: 1.6rem;
  color: var(--text);
  margin: 0;
  font-style: italic;
}

.welcome-message-text.neutral {
  font-family: var(--font-clean);
  font-size: 1rem;
  color: #777777;
  font-style: normal;
}

/* TRUE WINDOW VIEWPORT FIXED CONFETTI ENGINE */
.confetti-container {
  position: fixed; 
  top: 0; left: 0; width: 100vw; height: 100vh;
  pointer-events: none; 
  z-index: 9999; 
  overflow: hidden;
}

.confetti-piece {
  position: absolute;
  top: -20px;
  pointer-events: none;
}

/* ==========================================================================
   LARGE SCREEN & ULTRA-WIDE MONITOR OPTIMIZATIONS
   ========================================================================== */
@media (min-width: 1400px) {
  .hero-section::before,
  .parallax-divider::before {
    background-position: center 30% !important;
  }
}

@media (min-width: 2000px) {
  .hero-section::before {
    background-size: 100% auto !important;
    background-position: center center !important;
  }
  .main-text {
    max-width: 750px;
    font-size: 1.2rem;
  }
}

@media (max-height: 750px) and (min-width: 769px) {
  .hero-section h1 { font-size: 3.5rem; }
  .sticky-nav { top: 10px; padding: 10px 20px; }
}

/* ==========================================================================
   CRITICAL MOBILE SCREEN OVERHAUL RE-ENGINE
   ========================================================================== */
@media (max-width: 768px) {
  .guest-fields-stack input,
  .guest-fields-stack select,
  .elegant-form textarea {
    padding: 14px 16px;
  }
  
  h2, .section-title {
    font-size: 2.4rem; 
  }

  .location-name {
    font-size: 1.6rem; 
  }

  /* FIXED THE POSITION BUG: Smoothly scales the whole button wrapper container up when active */
  .sticky-nav {
    position: fixed !important;
    top: 20px; 
    right: 20px; 
    left: auto;
    width: 52px; 
    height: 52px;
    padding: 0; 
    margin: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 8px 25px rgba(164, 195, 178, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    overflow: hidden; /* Hides menu links cleanly while drawer is shut */
    transition: all 0.4s cubic-bezier(0.1, 0.8, 0.25, 1);
  }

  /* Opens up context mapping boundary rules so it floods the mobile view perfectly */
  .sticky-nav.mobile-nav-active {
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: none;
    overflow: visible;
  }

  /* Hamburger toggle switch mechanics */
  .menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 22px; 
    height: 15px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 10002;
    outline: none;
    position: absolute;
    transition: all 0.3s ease;
  }

  /* Keeps the toggle button perfectly pinned in the top-right corner when overlay is active */
  .sticky-nav.mobile-nav-active .menu-toggle {
    top: 38px;
    right: 35px;
  }

  .menu-toggle .bar {
    width: 100%; 
    height: 2px;
    background-color: var(--text);
    transition: transform 0.4s cubic-bezier(0.1, 0.8, 0.25, 1), opacity 0.3s ease, background-color 0.3s ease;
    transform-origin: left center;
  }

  .menu-toggle .bar.open:nth-child(1) {
    transform: rotate(45deg) translate(2px, -2px);
    background-color: #C94A4A; 
  }
  
  .menu-toggle .bar.open:nth-child(2) {
    opacity: 0; 
    transform: scaleX(0);
  }
  
  .menu-toggle .bar.open:nth-child(3) {
    transform: rotate(-45deg) translate(2px, 2px);
    background-color: #C94A4A;
  }

  /* Full screen vertical drawer menu option container styles */
  .nav-links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    width: 100%;
    height: 100%;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }

  /* Reveals the links with an elegant fade-in once container handles expansion */
  .nav-links.show {
    opacity: 1;
    visibility: visible;
  }

  .sticky-nav a {
    font-family: var(--font-classy) !important; 
    font-size: 1.6rem;
    letter-spacing: 3px;
    color: var(--text);
    padding: 8px 40px;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
  }

  .sticky-nav a:hover {
    color: var(--sage);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,eAAe,QAAQ,6BAA6B;EACpD,eAAe;EACf,aAAa;EACb,kBAAkB,KAAK,0DAA0D;EACjF,eAAe;EACf,mBAAmB,IAAI,iDAAiD;EACxE,mBAAmB,IAAI,uDAAuD;;EAE9E,uCAAuC;EACvC,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA,OAAO,uBAAuB,EAAE;;AAEhC,uBAAuB;AACvB;;;;;;;;;;;EAWE,8BAA8B;AAChC;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C;6FAC2F;EAC3F,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc,mBAAmB,EAAE,iBAAiB,EAAE;AACtD,mBAAmB,mCAAmC,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1F,aAAa,WAAW,EAAE,WAAW,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAErF,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C,aAAa,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEhE,gBAAgB,eAAe,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AAClF,mBAAmB,eAAe,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC1F,oBAAoB,eAAe,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AACtF,gBAAgB,eAAe,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;;AAEvF,yBAAyB;AACzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,aAAa,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,WAAW,EAAE;;AAEtG,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C,0IAA0I;EAC1I,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,4HAA4H;EAC5H,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,gDAAgD;EAChD,yBAAyB;EACzB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,yEAAyE;EACzE,iCAAiC;EAGjC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB,OAAO,8CAA8C;EAC5E,2BAA2B,GAAG,2CAA2C;AAC3E;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,iBAAiB,0CAA0C;EAC5E,eAAe,eAAe,2CAA2C;EACzE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,UAAU;AACZ;;AAEA,SAAS,YAAY,EAAE;;AAEvB,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iDAAiD;EACjD,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;;EAE/B,aAAa;EACb,uBAAuB;EACvB,qBAAqB,GAAG,4DAA4D;EACpF,oBAAoB,SAAS,oDAAoD;EACjF,sBAAsB,IAAI,0DAA0D;;EAEpF,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,sCAAsC,sBAAsB,EAAE;AAC9D,0CAA0C,oCAAoC,EAAE;AAChF,+CAA+C,uBAAuB,EAAE,yBAAyB,EAAE;;AAEnG,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA,WAAW;AACX,UAAU,eAAe,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,WAAW,EAAE;;AAEpG,qBAAqB;AACrB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,YAAY,EAAE,aAAa;EAC5C,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;+EAE+E;AAC/E;EACE;;IAEE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6CAA6C;EAC/C;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB,iBAAiB,EAAE;EACtC,cAAc,SAAS,EAAE,kBAAkB,EAAE;AAC/C;;AAEA;;+EAE+E;AAC/E;EACE;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,8FAA8F;EAC9F;IACE,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,gDAAgD;IAChD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB,EAAE,kDAAkD;IACpE,oDAAoD;EACtD;;EAEA,mFAAmF;EACnF;IACE,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,4FAA4F;EAC5F;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,yGAAyG;IACzG,6BAA6B;EAC/B;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;EAC3B;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mDAAmD;EACrD;;EAEA,+EAA+E;EAC/E;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Montserrat:wght@200;400;500;600&display=swap');\n\n:root {\n  --sage: #A4C3B2;       /* Premium Light Mint Green */\n  --gold: #C5A059;\n  --bg: #FFFFFF;\n  --bg-soft: #F4F7F5;    /* Luxury ultra-faint mint cream to fill out empty space */\n  --text: #333333;\n  --radius-soft: 16px;   /* Organic rounded corners for cards and blocks */\n  --radius-pill: 30px;   /* Perfectly rounded edges for buttons and navigation */\n  \n  /* Strict Typography Design Variables */\n  --font-classy: 'Cormorant Garamond', serif;\n  --font-clean: 'Montserrat', sans-serif;\n}\n\nhtml { scroll-behavior: smooth; }\n\n/* GLOBAL FONTS RESET */\nbody, \ninput, \nselect, \ntextarea, \nbutton, \n.sticky-nav a, \n.t-item span, \n.t-item p, \n.calendar-date, \n.hero-label,\n.map-card-overlay span {\n  font-family: var(--font-clean);\n}\n\nh1, h2, h3, h4, \n.section-title, \n.location-name, \n.quote-text,\n.footer p {\n  font-family: var(--font-classy);\n}\n\nbody {\n  margin: 0;\n  color: var(--text);\n  background-color: var(--bg);\n}\n\n/* GLOBAL WRAPPER */\n.timeless-wrapper {\n  overflow-x: hidden;\n  position: relative;\n}\n\n/* ==========================================================================\n   MODERN HIGH-PERFORMANCE PARALLAX CLIPPED ENGINE \n   ========================================================================== */\n.hero-section {\n  position: relative;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n  clip-path: inset(0 0 0 0);\n  overflow: hidden;\n}\n\n.hero-section::before {\n  content: \"\";\n  position: fixed;\n  top: 0; left: 0; width: 100%; height: 100%;\n  background: linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.25)), \n              url('https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2000');\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n  will-change: transform;\n}\n\n.hero-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden; \n}\n\n.hero-label { letter-spacing: 5px; font-size: 0.8rem; }\n.hero-section h1 { font-size: clamp(3rem, 9vw, 5.5rem); font-weight: 500; margin: 15px 0; }\n.gold-line { width: 60px; height: 1px; background: var(--gold); margin: 0 auto 20px; }\n\n/* NAVIGATION SYSTEM LAYER (DESKTOP DEFAULT) */\n.sticky-nav {\n  position: sticky;\n  top: 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(5px);\n  padding: 15px 30px;\n  z-index: 1000;\n  max-width: 500px;\n  margin: 0 auto;\n  border-radius: var(--radius-pill);\n  box-shadow: 0 10px 30px rgba(164, 195, 178, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.nav-links {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  width: 100%;\n}\n\n.sticky-nav a {\n  text-decoration: none;\n  color: var(--text);\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  font-weight: 500;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sticky-nav a:hover {\n  color: var(--sage);\n}\n\n.menu-toggle {\n  display: none;\n}\n\n/* CONTENT LAYOUT & ALTERNATING SECTIONS */\n.container { max-width: 900px; margin: 0 auto; padding: 0 20px; }\n\n.info-section { padding: 60px 0; text-align: center; background-color: var(--bg); }\n.program-section { padding: 60px 0; text-align: center; background-color: var(--bg-soft); }\n.location-section { padding: 60px 0; text-align: center; background-color: var(--bg); }\n.rsvp-section { padding: 60px 0; text-align: center; background-color: var(--bg-soft); }\n\n/* LUXURY H2 TYPOGRAPHY */\nh2, .section-title { \n  font-size: 3.2rem;       \n  font-weight: 500; \n  letter-spacing: 1.5px;   \n  color: var(--sage); \n  margin-bottom: 25px; \n  line-height: 1.2;\n}\n\n.main-text { font-size: 1.1rem; line-height: 1.9; max-width: 630px; margin: 0 auto 50px; color: #555; }\n\n/* ROMANTIC QUOTE BANNER */\n.quote-banner {\n  padding: 60px 20px;\n  background: var(--bg-soft);\n  text-align: center;\n  border-top: 1px solid rgba(164, 195, 178, 0.15);\n  border-bottom: 1px solid rgba(164, 195, 178, 0.15);\n}\n\n.quote-text {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1.6rem;\n  color: var(--text);\n  max-width: 550px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* IMAGES */\n.mid-photo { \n  width: 100%; \n  max-height: 550px; \n  object-fit: cover; \n  border-radius: var(--radius-soft); \n  box-shadow: 0 15px 40px rgba(0,0,0,0.06);\n}\n\n/* HIGH-PERFORMANCE CLIPPED PARALLAX IMAGE DIVIDER */\n.parallax-divider {\n  position: relative;\n  height: 55vh;\n  clip-path: inset(0 0 0 0);\n  overflow: hidden;\n}\n\n.parallax-divider::before {\n  content: \"\";\n  position: fixed;\n  top: 0; left: 0; width: 100%; height: 100%;\n  background-image: url('https://raw.githubusercontent.com/petyonachev92/wedding_website/refs/heads/main/client/public/images/MPN03338.JPG');\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n  will-change: transform;\n}\n\n/* OPTICALLY BALANCED ASYMMETRIC TIMELINE */\n.timeline-list { \n  margin-top: 40px; \n  background: white;\n  padding: 10px;\n  border-radius: var(--radius-soft);\n  box-shadow: 0 10px 30px rgba(164, 195, 178, 0.08);\n  max-width: 420px; \n  margin-left: auto;\n  margin-right: auto;\n  position: relative; \n}\n\n.timeline-list::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  bottom: 10px;\n  left: 29%; \n  width: 1px;\n  background: linear-gradient(to bottom, transparent, rgba(197, 160, 89, 0.25) 15%, rgba(197, 160, 89, 0.25) 85%, transparent);\n  transform: translateX(-50%);\n}\n\n.t-item {\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 2; \n  padding: 16px 0;\n}\n\n.t-item span { \n  font-weight: 600; \n  color: var(--gold); \n  width: 28%; \n  text-align: right; \n  padding-right: 15px; \n  box-sizing: border-box;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.t-item p {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text);\n  width: 72%; \n  text-align: left; \n  padding-left: 15px; \n  box-sizing: border-box;\n  line-height: 1.3; \n}\n\n/* CALENDAR SECTION INTERACTIVITY */\n.calendar-section {\n  padding: 60px 0;\n  background-color: var(--bg);\n  text-align: center;\n}\n\n.calendar-card {\n  max-width: 350px;\n  margin: 0 auto;\n  background: white;\n  padding: 35px 30px;\n  border-radius: var(--radius-soft);\n  box-shadow: 0 15px 40px rgba(164, 195, 178, 0.1);\n  border: 1px solid #eef2ef;\n  cursor: pointer; \n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s ease;\n}\n\n.calendar-header h3 {\n  font-family: var(--font-classy) !important;\n  font-weight: 500;\n  letter-spacing: 3px;\n  font-size: 1.45rem;\n  color: var(--text);\n  margin-bottom: 25px;\n\n  /* FORCES NUMBERS TO MATCH THE HEIGHT AND ALIGNMENT OF CYRILLIC LETTERS */\n  font-variant-numeric: lining-nums;\n  -moz-font-feature-settings: \"lnum\" 1;\n  -webkit-font-feature-settings: \"lnum\" 1;\n  font-feature-settings: \"lnum\" 1;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.calendar-day-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: var(--sage);\n  margin-bottom: 10px;\n}\n\n.calendar-date-wrapper {\n  position: relative;\n  width: 100%;\n  height: 40px; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.calendar-date {\n  font-size: 0.95rem;\n  color: #777;\n  z-index: 5;\n  position: relative;\n  line-height: 1; \n  pointer-events: none;\n}\n\n.heart-marker {\n  position: absolute;\n  top: 46%; \n  left: 50%;\n  transform: translate(-50%, -43%) !important; \n  width: 60px;\n  height: 60px;\n  z-index: 2;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none !important;      /* Removes any trace of the old ring borders */\n  background: none !important;  /* Clears any leftover circle backgrounds */\n}\n\n/* Premium vibrant red filling and shading adjustments */\n.heart-svg {\n  width: 100%;\n  height: 100%;\n  fill: var(--sage);                /* High-contrast romantic red fill color */\n  stroke: #77b894;              /* Crisp matching border accent alignment */\n  stroke-width: 1;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.wedding-day {\n  color: #ffffff !important;\n  font-weight: 700;\n  font-size: 1.55rem !important;\n}\n\n.ring-marker {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important; \n  width: 36px;\n  height: 36px;\n  border: 2px solid var(--gold);\n  border-radius: 50%;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.diamond {\n  position: absolute;\n  top: -5px;\n  left: calc(50% - 4px); \n  width: 6px;\n  height: 6px;\n  background: white;\n  border: 2px solid var(--gold);\n  transform: rotate(45deg);\n  z-index: 3;\n}\n\n.empty { height: 35px; }\n\n/* REBALANCED VISUAL WEIGHT LOCATION CARDS */\n.location-name {\n  font-size: 2.1rem;        \n  font-weight: 500;\n  letter-spacing: 0.5px;\n  color: var(--gold);       \n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n\n.location-address {\n  font-size: 0.9rem;\n  color: #777;\n  margin-bottom: 30px;\n}\n\n.location-instructions {\n  font-size: 1rem;\n  color: var(--text);\n  line-height: 1.9;\n  max-width: 630px;\n  margin: 0 auto 50px;\n}\n\n.map-image-card {\n  position: relative;\n  max-width: 800px;\n  height: 400px;\n  margin: 0 auto 30px;\n  box-shadow: 0 15px 35px rgba(164, 195, 178, 0.15);\n  border-radius: var(--radius-soft);\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.map-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.map-card-overlay {\n  position: absolute;\n  top: 0; \n  left: 0; \n  width: 100%; \n  height: 100%;\n  background: rgba(0, 0, 0, 0.12);\n  \n  display: flex;\n  justify-content: center;\n  align-items: flex-end;  /* Changed from 'center' to push the badge to the top edge */\n  padding-bottom: 35px;        /* Adds elegant breathing room from the top border */\n  box-sizing: border-box;   /* Prevents the padding from distorting the overlay size */\n  \n  z-index: 2;\n  transition: background 0.4s ease;\n}\n\n.map-card-overlay span {\n  color: white;\n  font-size: 0.8rem;\n  letter-spacing: 3px;\n  font-weight: 500;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  padding: 12px 24px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-pill);\n  transition: all 0.4s ease;\n}\n\n.map-image-card:hover .map-card-img { transform: scale(1.03); }\n.map-image-card:hover .map-card-overlay { background: rgba(164, 195, 178, 0.3); }\n.map-image-card:hover .map-card-overlay span { background: var(--sage); border-color: var(--sage); }\n\n/* RSVP STACK ARCHITECTURE */\n.rsvp-box { \n  background: white; \n  padding: 50px; \n  border-radius: var(--radius-soft); \n  box-shadow: 0 15px 45px rgba(164, 195, 178, 0.1); \n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.elegant-form { \n  display: flex; \n  flex-direction: column; \n  gap: 20px; \n  width: 100%;\n  max-width: 550px; \n  margin: 30px auto 0; \n}\n\n.guests-loop-container,\n.elegant-form textarea,\n.add-guest-action-btn,\n.gold-btn {\n  width: 100%;\n  box-sizing: border-box; \n}\n\n.guest-row-card {\n  background: #fafbfa;\n  border: 1px solid #eef2ef;\n  border-left: 4px solid var(--sage);\n  padding: 25px;\n  border-radius: var(--radius-soft);\n  text-align: left;\n  box-sizing: border-box; \n}\n\n.guest-row-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.guest-row-header h4 {\n  margin: 0;\n  font-size: 1.2rem; \n  letter-spacing: 0.5px;\n  color: var(--text);\n  font-weight: 500;\n}\n\n.remove-guest-btn {\n  background: transparent;\n  border: none;\n  color: #c94a4a;\n  font-size: 0.75rem;\n  cursor: pointer;\n  letter-spacing: 1px;\n}\n\n.guest-fields-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; \n  width: 100%;\n  box-sizing: border-box;\n}\n\n.form-field-row {\n  width: 100%;\n  position: relative;\n}\n\n.guest-fields-stack input,\n.guest-fields-stack select,\n.elegant-form textarea {\n  width: 100% !important;\n  box-sizing: border-box;\n  padding: 16px 20px; \n  border: 1px solid #e2e8e4;\n  background-color: white;\n  border-radius: 12px; \n  font-size: 0.95rem;\n  color: var(--text);\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.guest-fields-stack input:focus, \n.guest-fields-stack select:focus, \n.elegant-form textarea:focus {\n  outline: none;\n  border-color: var(--sage);\n  box-shadow: 0 0 0 3px rgba(164, 195, 178, 0.12);\n}\n\n.guest-fields-stack select {\n  cursor: pointer;\n  appearance: none; \n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23C5A059' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 18px center;\n  background-size: 16px;\n  padding-right: 45px; \n}\n\n.add-guest-action-btn {\n  background: transparent;\n  border: 1px dashed var(--sage);\n  color: var(--sage);\n  padding: 15px; \n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 5px 0;\n  text-transform: uppercase;\n  border-radius: var(--radius-pill);\n}\n\n.add-guest-action-btn:hover {\n  background: rgba(164, 195, 178, 0.1); \n  border-color: var(--gold);\n  color: var(--gold);\n}\n\n.gold-btn {\n  background: var(--sage);\n  color: white;\n  border: none;\n  padding: 18px;\n  letter-spacing: 2px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: var(--radius-pill);\n  box-shadow: 0 5px 20px rgba(164, 195, 178, 0.2);\n}\n\n.gold-btn:hover { \n  background: var(--gold); \n  box-shadow: 0 5px 20px rgba(197, 160, 89, 0.3);\n}\n\n/* FOOTER */\n.footer { padding: 60px 0; text-align: center; font-size: 0.8rem; letter-spacing: 2px; color: #777; }\n\n/* ERROR CONTAINERS */\n.error-message-box {\n  background-color: #FDF4F4; \n  border-left: 4px solid #C94A4A; \n  padding: 15px 20px;\n  border-radius: 12px;\n  text-align: left;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.error-message-box p {\n  margin: 0;\n  color: #C94A4A;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  font-weight: 500;\n}\n\n/* SUCCESS TEXT LAYOUT PANELS */\n.success-message-wrapper {\n  text-align: center;\n  padding: 30px 10px;\n  position: relative; \n}\n\n.success-message-wrapper h3 {\n  font-size: 2.6rem;\n  color: var(--sage);\n  margin: 0 0 15px 0;\n  font-weight: 500;\n}\n\n.welcome-message-text {\n  font-family: var(--font-classy); \n  font-size: 1.6rem;\n  color: var(--text);\n  margin: 0;\n  font-style: italic;\n}\n\n.welcome-message-text.neutral {\n  font-family: var(--font-clean);\n  font-size: 1rem;\n  color: #777777;\n  font-style: normal;\n}\n\n/* TRUE WINDOW VIEWPORT FIXED CONFETTI ENGINE */\n.confetti-container {\n  position: fixed; \n  top: 0; left: 0; width: 100vw; height: 100vh;\n  pointer-events: none; \n  z-index: 9999; \n  overflow: hidden;\n}\n\n.confetti-piece {\n  position: absolute;\n  top: -20px;\n  pointer-events: none;\n}\n\n/* ==========================================================================\n   LARGE SCREEN & ULTRA-WIDE MONITOR OPTIMIZATIONS\n   ========================================================================== */\n@media (min-width: 1400px) {\n  .hero-section::before,\n  .parallax-divider::before {\n    background-position: center 30% !important;\n  }\n}\n\n@media (min-width: 2000px) {\n  .hero-section::before {\n    background-size: 100% auto !important;\n    background-position: center center !important;\n  }\n  .main-text {\n    max-width: 750px;\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-height: 750px) and (min-width: 769px) {\n  .hero-section h1 { font-size: 3.5rem; }\n  .sticky-nav { top: 10px; padding: 10px 20px; }\n}\n\n/* ==========================================================================\n   CRITICAL MOBILE SCREEN OVERHAUL RE-ENGINE\n   ========================================================================== */\n@media (max-width: 768px) {\n  .guest-fields-stack input,\n  .guest-fields-stack select,\n  .elegant-form textarea {\n    padding: 14px 16px;\n  }\n  \n  h2, .section-title {\n    font-size: 2.4rem; \n  }\n\n  .location-name {\n    font-size: 1.6rem; \n  }\n\n  /* FIXED THE POSITION BUG: Smoothly scales the whole button wrapper container up when active */\n  .sticky-nav {\n    position: fixed !important;\n    top: 20px; \n    right: 20px; \n    left: auto;\n    width: 52px; \n    height: 52px;\n    padding: 0; \n    margin: 0;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.98);\n    box-shadow: 0 8px 25px rgba(164, 195, 178, 0.25);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n    overflow: hidden; /* Hides menu links cleanly while drawer is shut */\n    transition: all 0.4s cubic-bezier(0.1, 0.8, 0.25, 1);\n  }\n\n  /* Opens up context mapping boundary rules so it floods the mobile view perfectly */\n  .sticky-nav.mobile-nav-active {\n    top: 0;\n    right: 0;\n    width: 100vw;\n    height: 100vh;\n    border-radius: 0;\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    box-shadow: none;\n    overflow: visible;\n  }\n\n  /* Hamburger toggle switch mechanics */\n  .menu-toggle {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 22px; \n    height: 15px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    z-index: 10002;\n    outline: none;\n    position: absolute;\n    transition: all 0.3s ease;\n  }\n\n  /* Keeps the toggle button perfectly pinned in the top-right corner when overlay is active */\n  .sticky-nav.mobile-nav-active .menu-toggle {\n    top: 38px;\n    right: 35px;\n  }\n\n  .menu-toggle .bar {\n    width: 100%; \n    height: 2px;\n    background-color: var(--text);\n    transition: transform 0.4s cubic-bezier(0.1, 0.8, 0.25, 1), opacity 0.3s ease, background-color 0.3s ease;\n    transform-origin: left center;\n  }\n\n  .menu-toggle .bar.open:nth-child(1) {\n    transform: rotate(45deg) translate(2px, -2px);\n    background-color: #C94A4A; \n  }\n  \n  .menu-toggle .bar.open:nth-child(2) {\n    opacity: 0; \n    transform: scaleX(0);\n  }\n  \n  .menu-toggle .bar.open:nth-child(3) {\n    transform: rotate(-45deg) translate(2px, 2px);\n    background-color: #C94A4A;\n  }\n\n  /* Full screen vertical drawer menu option container styles */\n  .nav-links {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 32px;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n  }\n\n  /* Reveals the links with an elegant fade-in once container handles expansion */\n  .nav-links.show {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .sticky-nav a {\n    font-family: var(--font-classy) !important; \n    font-size: 1.6rem;\n    letter-spacing: 3px;\n    color: var(--text);\n    padding: 8px 40px;\n    width: 100%;\n    text-align: center;\n    box-sizing: border-box;\n  }\n\n  .sticky-nav a:hover {\n    color: var(--sage);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
